import React from "react";
import './style.scss';
import TrafficPermissionContent from './../../components/TrafficPermissionContent';

export default function LogMonitor()  {
 
  return (
    <div className="createApp">
      <TrafficPermissionContent></TrafficPermissionContent>
    </div>
  );
}